import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  * {
    font-family: ManropeRegular;
  }
  body {
    overflow-x: hidden;
    min-height: 100vh;
    // background-image:url('/assets/home/backgroundV1.svg');
    background-position: center;
    position: relative;
    z-index: 99;
  
    img {
      height: auto;
      max-width: 100%;
    }
  }
  iframe {
    display: none;
  }

  li {
      list-style-type: none
    }
`;

export default GlobalStyle;
